import create from 'zustand';

type LearnerFabClusterState = {
  openSalesBot: (() => void) | null;
  registerSalesBotOpener: (openSalesBot: (() => void) | null) => void;
  isMenuOpen: boolean;
  setMenuOpen: (isMenuOpen: boolean) => void;
  closeTtuTooltip: (() => void) | null;
  registerTtuTooltipCloser: (closeTtuTooltip: (() => void) | null) => void;
};

const useLearnerFabClusterStore = create<LearnerFabClusterState>((set) => ({
  openSalesBot: null,
  registerSalesBotOpener: (openSalesBot) => set({ openSalesBot }),
  isMenuOpen: false,
  setMenuOpen: (isMenuOpen) =>
    set((state) => (state.isMenuOpen === isMenuOpen ? state : { isMenuOpen })),
  closeTtuTooltip: null,
  registerTtuTooltipCloser: (closeTtuTooltip) => set({ closeTtuTooltip })
}));

export default useLearnerFabClusterStore;
